<template>
  <div class="iframe-wrap">
      <div v-if="loading" style="display: inline-block;width: 100%;height: 300px;position: relative;">
        <Spin size="large" fix></Spin>
      </div>
    <iframe ref="iframeRef" :src="url" style="width: 100%;height: 100%;border: none;z-index: 9;"></iframe>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.iframeRef.onload = () => {
        this.loading = false;
        this.$refs.iframeRef.contentWindow.postMessage(this.$store.state.user , '*')
      }
    });
  }
};
</script>
<style lang="less">
.iframe-wrap {
  height: 100%;
  background: #fff;
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #999;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:vertical:hover {
    background-color: #666;
  }
  ::-webkit-scrollbar-thumb:vertical:active {
    background-color: #333;
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }
  form{
    width: 600px !important;
  }
}
</style>
